import api from './../../service/apiService'
import { apiUrl } from './../../constants/apiUrl'
import { logKafka, logOtherInfo, detailsInfo, catchJSException } from './../../service/logService';
import { CheckOut, Deposit, FinalBill, Pages, InstallationConstants, MTNValidation, PAGEACTIVITY } from './../../constants/actionType'
import { errorAction } from './error';
import { redirectTo } from './redirection'
import { creditInfoUpdate } from './../../service/aimsChat.js'
import { getCartHeader, getCartData } from './../../util/change/cartUtility'
//import * as resp from './../containers/checkout/sampleCreditResponse'
//import * as duedatesample from './../containers/checkout/dueDataSampleJson'
import { updateSCcustomEvent, tempSCData, scDataDetails } from './../../service/change/dtmTag';
import { validateVZWOfferEligibility } from './loopQual'
import * as submitOrderAction from './submitOrder'
import { InHomeUtils } from './../../util/inhomeUtils';
import { logNRTime } from './../../util/commonUtil';
import { vzdlBuildProductPageEvents } from './../../service/change/vzdl';
//import * as socAction from './buildProduct'
import * as buildProductAction from './../../action/change/buildProduct'
import { store } from "../../../src/index"/**importing store for reducer values */

let reserveDueDateAPICount = 0;
let getDueDatesAPICount = 0;
let setDueDateAPIFailCount = 0;
let setDueDateAPIRetryCount = 0;
let getLogUrl = apiUrl().kafkaErrorAppLogs;
let kafkaPageLogs = apiUrl().kafkaPageLogs;
/* Checkout steps accordion */
export const gotoCheckoutStep = (stepNumber, dispatch) => {
    dispatch({
        type: 'GOTO_CHECKOUT_STEP',
        value: stepNumber
    })
}

export const updatePersonalInfoAccordion = (action, dispatch) => {
    dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: action })
}

export const updateSatelliteAccordion = (action, dispatch) => {
    dispatch({ type: CheckOut.updateSatelliteAccordionStatus, value: action })
}

export const updateCreditCheckAccordion = (action, dispatch) => {
    dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: action })
}

export const updateInstallationAccordion = (action, dispatch) => {
    dispatch({ type: CheckOut.updateInstallationAccordionStatus, value: action })
}

export const updateAutoPayAccordion = (action, dispatch) => {
    dispatch({ type: CheckOut.updateAutoPayAccordionStatus, value: action })
}

export const updateReviewOrderAccordion = (action, dispatch) => {
    dispatch({ type: CheckOut.updateReviewOrderAccordionStatus, value: action })
}

export const updateTOSAccordion = (action, dispatch) => {
    dispatch({ type: CheckOut.updateTosAccordionStatus, value: action })
}

export const updateDepositAccordion = (action, dispatch) => {
    dispatch({ type: CheckOut.updateDepositAccordionStatus, value: action })
}

export const onCreditStatusChange = (dispatch, creditFailAttempts) => {
    dispatch({ type: CheckOut.updateInitialState })
    dispatch({ type: CheckOut.updateCreditFailAttempts, value: creditFailAttempts })
    dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'required' })
}

export const PrevSelectedProdAccordion = (SelectedProd, dispatch) => {
    dispatch({ type: CheckOut.PrevSelectedProd, value: SelectedProd })
}

export const paymentClicked = (status, dispatch) => {
    dispatch({ type: Deposit.depositPaymentClicked, value: status })
};

export const depositAddressCheck = (status, dispatch) => {
    dispatch({ type: Deposit.depositAddressCheck, value: status })
};

export const depositdebitCheck = (status, dispatch) => {
    dispatch({ type: Deposit.depositdebitCheck, value: status })
};

export const updateFinalBillOption = (dispatch, val) => {
    dispatch({ type: FinalBill.updateFinalBillOption, value: val })
}

export const setShippingStatus = (status,dispatch) => {
    dispatch({ type: 'SET_SHIPPING_STATUS', value: status })
}

export const finalBilldebitCheck = (status, dispatch) => {
    dispatch({ type: FinalBill.finalBilldebitCheck, value: status })
};

export const finalBillAddressCheck = (status, dispatch) => {
    dispatch({ type: FinalBill.finalBillAddressCheck, value: status })
};

export const updateSSNandDOBStatus = (ssnFilled, dobFilled, dispatch) => {
    dispatch({ type: CheckOut.updateSSNandDOBStatus, value: { dobFilled: dobFilled, ssnFilled: ssnFilled } })
}
export const setClickMNHAutopayTaggingFired = (value, dispatch) => {
    dispatch({ type: 'MNH_AUTOPAY_OPTION_CLICK_TAGGING_FIRED', value: value });
}

export const setCartDirtyFlag = (status, dispatch) => {
    dispatch({ type: 'SET_CART_DIRTY', value: status })
}

export const apDiscountInCart = (dispatch) => {
    let autoPayinCart = buildProductAction.isAutoPayInCart(store.getState().app.visitId, store.getState().cart);
    dispatch({ type: 'AP_DISCOUNT_INCART', value: autoPayinCart });
};

export const onFinalBillContinueClick = (dispatch, val, visitId) => {
    if (val === 'success') {
        dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: true })
        dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'completed' })
        dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: 'completed' })
    }
    if (val === 'No' || val === 'fail') {
        dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: false })
        dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'change' })
        dispatch({ type: CheckOut.updateFinalBillStatus, value: false })
        dispatch({ type: CheckOut.updateRTAStatus, value: false })
    }
    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.FB, PAGEACTIVITY.MSG.CD, PAGEACTIVITY.UA));
}

export const validateFinalBill = (action, dispatch) => {
    dispatch({
        type: FinalBill.validateFinalBill,
        value: action
    });
}

//UpdateIntent Call is to update cart with Specified installtion type, so that appropriate usoc will be added to cart.
export const updateIntent = (visitId, installType, dispatch, retryCount = 0) => {
    try {
        let url = apiUrl().updateintentcartAccEc + '/' + visitId;
        let request = getInstallTypeRequest(installType, visitId);
        return new Promise((resolve, reject) => {

        api(url, 'POST', request).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.cartTierPricing)) {
                //Process response and do prefetch
                dispatch({
                    type: "UPDATE_CART",
                    value: {
                        cartResponse: response.data.cartTierPricing,
                        cartHeader: getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                        cartData: getCartData(response.data.cartTierPricing.tierContent, visitId),
                        cartOrderDetail: response.data.orderDetail
                    }
                });
                buildProductAction.checkNewProductAddedOrNot(dispatch)
                resolve('Done');
            }
            else if (retryCount < 3) {
                updateIntent(visitId, installType, dispatch, (retryCount+1)).then(resolve);
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.CART, 'CART Intent Error', PAGEACTIVITY.UA));
                resolve('Error');
            }
        })
            .catch(error => {
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:updateIntent, errorMessage: ${error.message}`;
                logKafka("ERROR", "UpdateCart", errorMsg, getErrorLogUrl, "applogs", visitId);
                resolve('Error');
            });
        });
    }
    catch (ex) {
        catchJSException('Checkout', visitId, 'updateIntenet', ex);
    }
}

//UpdateIntent Call is to update cart with Specified installtion type, so that appropriate usoc will be added to cart.
export const updateSecureHomeIntent = (visitId, installType, dispatch, dhsIsocId,dhsAction,   retryCount = 0) => {
    try {
        let url = apiUrl().updateCartAcc + '/' + visitId;
        let request = {
            contract: "MTM",
            productId: dhsIsocId,
            productType: "DHSBILLER",
            quantity: 1,
            serviceType: "DATA",
            status:  dhsAction === "Cancel" ? "remove" : "add",
            isMnHAuthenticated : "",
        }
    
        return new Promise((resolve, reject) => {

        api(url, 'POST', JSON.stringify(request)).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.cartTierPricing)) {
                //Process response and do prefetch
                dispatch({
                    type: "UPDATE_CART",
                    value: {
                        cartResponse: response.data.cartTierPricing,
                        cartHeader: getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                        cartData: getCartData(response.data.cartTierPricing.tierContent, visitId),
                        cartOrderDetail: response.data.orderDetail
                    }
                });
                buildProductAction.checkNewProductAddedOrNot(dispatch)
                resolve('Done');
            }
            else if (retryCount < 3) {
                updateIntent(visitId, installType, dispatch, (retryCount+1)).then(resolve);
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.CART, 'CART Intent Error', PAGEACTIVITY.UA));
                resolve('Error');
            }
        })
            .catch(error => {
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:updateIntent, errorMessage: ${error.message}`;
                logKafka("ERROR", "UpdateCart", errorMsg, getErrorLogUrl, "applogs", visitId);
                resolve('Error');
            });
        });
    }
    catch (ex) {
        catchJSException('Checkout', visitId, 'updateIntenet', ex);
    }
}


const getInstallTypeRequest = (installType, visitId) => {
    try {
        let request = {
            key: InstallationConstants.key,
            value: installType === "O" ? InstallationConstants.techInstall : InstallationConstants.selfInstall,
            action: "add"
        }
        return JSON.stringify(request)
    }
    catch (ex) {
        catchJSException('Checkout', visitId, 'getInstallTypeRequest', ex);
    }
}

export const doValidateCart = (visitId, dispatch, reAttemptCount = 0, postSoc, ischurnkey = false, isACPFlow = false) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'doValidateCart', "Inside doValidateCart"));
        logKafka("INFO", "UpdateCart", "Inside doValidateCart", kafkaPageLogs, "applogs", visitId);
        let validateCart = apiUrl().validatecartUrlEc + visitId;
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Checking out your cart", isLoaderImg: "loader" }
        });
        setCartDirtyFlag(false, dispatch);
        api(validateCart, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                dispatch({
                    type: "UPDATE_CART",
                    value: {
                        cartResponse: InHomeUtils.isNull(response.data.cartTierPricing) ? null : response.data.cartTierPricing,
                        cartHeader: InHomeUtils.isNull(response.data.cartTierPricing) ? null : getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                        cartData: InHomeUtils.isNull(response.data.cartTierPricing) ? null : getCartData(response.data.cartTierPricing.tierContent, visitId),
                        cartOrderDetail: InHomeUtils.isNull(response.data.cartTierPricing) ? null : response.data.orderDetail
                    }
                });
                dispatch({
                    type: 'CO_VALIDATE_CART_SUCCESS',
                    value: "ValidateCart Success"
                });
                if(isACPFlow){
                    buildProductAction.fetchPostSoc(dispatch, visitId);
                }
                if(ischurnkey && (response && response.data && response.data.cartTierPricing == null)){
                    errorAction("LBO", "Checkout", "chunkPromoOfferMissing", "applogs", visitId, dispatch, false, "");
                }
                else{
                    dispatch({type: 'UPDATE_PROMO_KEYWORD_FLOW', value: true});
                    redirectTo(Pages.Checkout, dispatch)
                }
            }
            else if (reAttemptCount < 2) {                
                logKafka("ERROR", "Checkout", "VOFailed", getLogUrl, "applogs", visitId);
                doValidateCart( visitId, dispatch, (reAttemptCount + 1),postSoc, ischurnkey);
            }
            //Failure Case
            else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.getIndexOf(response.meta.code, '500')) {
                dispatch({
                    type: 'CO_VALIDATE_CART_FAILURE',
                    value: "ValidateCart Failure"
                });
                logKafka("ERROR", "Checkout", "VOFailed", getLogUrl, "applogs", visitId);
                errorAction("LBO", "BuildProduct", "VOFailed", "applogs", visitId, dispatch, true, "VOFailed");
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            if (window.nrTimeState && window.nrTimeState.fromTime) {
                logNRTime(window.nrTimeState, dispatch, 'Checkout');
            }
            if(postSoc == "postSoc"){
                buildProductAction.fetchPostSoc(dispatch, visitId, false);
            }
        })
            .catch(error => {
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:doValidateCart,errorMessage:${error.message}`;
                logKafka("ERROR", "Checkout", errorMsg, getErrorLogUrl, "applogs");
                errorAction("LBO", "BuildProduct", error.message, "applogs", visitId, dispatch, true, "VOFailed");
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('Checkout', visitId, 'doValidateCart', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
};

export const doValidateCartBeforeOrderSubmission = (visitId, visitorId, dispatch, isTargetOrdering, pfbautopay) => {
    try {
        var didSucceed = false;
        let validateCart = apiUrl().validatecartUrlEc + visitId;
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Checking out your cart", isLoaderImg: "loader" }
        });
        setCartDirtyFlag(false, dispatch);
        api(validateCart, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, visitId, 'doValidateCartBeforeOrderSubmission', "VOBEFORESUBMIT-SUCCESS", PAGEACTIVITY.UA));
                logKafka("INFO", "Checkout", "VOBEFORESUBMIT-SUCCESS", kafkaPageLogs, "applogs");
                dispatch({
                    type: 'CO_VALIDATE_CART_SUCCESS',
                    value: "ValidateCart Success"
                });
                didSucceed = true;
            }
            //Failure Case
            else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '500')) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, visitId, 'doValidateCartBeforeOrderSubmission', "VOBEFORESUBMIT-FAILED", PAGEACTIVITY.UA));
                logKafka("ERROR", "Checkout", "VOBEFORESUBMIT-FAILED", getLogUrl, "applogs");
                dispatch({
                    type: 'CO_VALIDATE_CART_FAILURE',
                    value: "ValidateCart Failure"
                });
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, visitId, 'doValidateCartBeforeOrderSubmission', "VOBEFORESUBMIT-FAILED-OTHER", PAGEACTIVITY.UA));
                logKafka("ERROR", "Checkout", "VOBEFORESUBMIT-FAILED-OTHER", getLogUrl, "applogs");
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            if (window.nrTimeState && window.nrTimeState.fromTime) {
                logNRTime(window.nrTimeState, this.props.dispatch, 'Checkout');
            }
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, visitId, 'doValidateCartBeforeOrderSubmission', "SUBMITORDER-CALLED", PAGEACTIVITY.UA));
            logKafka("ERROR", "Checkout", "SUBMITORDER-CALLED", getLogUrl, "applogs");

            submitOrderAction.doSumbitOrder(visitId, visitorId, dispatch, isTargetOrdering, pfbautopay)
        })
            .catch(error => {
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:doValidateCartBeforeOrderSubmission,errorMessage:${error.message}`;
                logKafka("ERROR", "Checkout", errorMsg, getErrorLogUrl, "applogs");
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, visitId, 'doValidateCartBeforeOrderSubmission', "SUBMITORDER-CALLED-EXCEPTIONBLOCK", PAGEACTIVITY.UA));
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                submitOrderAction.doSumbitOrder(visitId, visitorId, dispatch, isTargetOrdering, pfbautopay)
            });
    }
    catch (ex) {
        catchJSException('Checkout', visitId, 'doValidateCartBeforeOrderSubmission', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
};

//begin installation
export const setInstallDate = (selInstallDate, selInstallDateFormatted, dispatch) => {
    dispatch({
        type: 'SET_INSTALL_DATE',
        value: {
            selInstallDate: selInstallDate,
            selInstallDateFormatted: selInstallDateFormatted
        }
    });

};

export const setDisconnectDate = (selDiscDate, selDiscDateFormatted, dispatch) => {
    dispatch({
        type: 'SET_DISCONNECT_DATE',
        value: {
            selDiscDate: selDiscDate,
            selDiscDateFormatted: selDiscDateFormatted
        }
    });

};

export const updateTimeSlots = (selInstallDate, dueDateResponse, dispatch, visitId) => {
    let timeSlots = [];
    try {

        let dueDateIndex = dueDateResponse.findIndex(el => el.dueDate === selInstallDate);

        if (dueDateIndex >= 0 && InHomeUtils.isNotNull(dueDateResponse[dueDateIndex].timeInterval)) {
            dueDateResponse[dueDateIndex].timeInterval.forEach(el => timeSlots.push({ displayTime: el.displayTime, reserveTime: el.reserveTime }));
        }

        if (InHomeUtils.isNotNull(timeSlots) && timeSlots.length > 0) {
            dispatch({
                type: 'UPDATE_TIME_SLOTS',
                value: timeSlots
            });
        }
    }
    catch (ex) {
        catchJSException('Checkout', visitId, 'action_updateTimeSlots', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
}

export const setInstallTimeSlot = (reserveTime, displayTime, dispatch) => {
    dispatch({
        type: 'SET_INSTALL_TIME_SLOT',
        value: { reserveTime: reserveTime, displayTime: displayTime }
    });
}

export const changeCalendar = (equipmentDelivery, dispatch) => {
    let value;

    switch (equipmentDelivery) {
        case 'pickUp':
            value = {
                selDueDateType: "EONTSELFINSTALL",
                selDeliveryOption: "PickUp"
            };
            break;
        case 'mailEquipment':
            value = {
                selDueDateType: "EONTSELFINSTALL",
                selDeliveryOption: "Mail"
            };
            break;
        case 'priorityShip':
            value = {
                selDueDateType: "EONTSELFINSTALL",
                selDeliveryOption: "PriorityShipping"
            };
            break;
        case 'sameDayDelivery':
            value = {
                selDueDateType: "EONTSELFINSTALL",
                selDeliveryOption: "SDD"
            };
            break;
        case 'packageLocker':
            value = {
                selDueDateType: "EONTSELFINSTALL",
                selDeliveryOption: "Locker"
            };
            break;
        default:
            break;
    }

    dispatch({
        type: 'CHANGE_INSTALL_CALENDAR',
        value: value
    });
};

export const toggleDirectShipSection = (showDirectShip, dispatch) => {
    dispatch({
        type: 'TOGGLE_DIRECT_SHIP_SECTION',
        value: showDirectShip
    })
};

export const setDirectShipEarliestDate = (earliestDate, dispatch) => {
    dispatch({
        type: 'SET_DIRECT_SHIP_EARLIEST_DATE',
        value: earliestDate
    })
};

export const setDirectShipSelection = (directShipSel, dispatch) => {
    dispatch({
        type: 'SET_DIRECT_SHIP_SELECTION',
        value: directShipSel
    })
};

//installation API
/*const dueDateSubmitRequest = (selectedDate) => {
    let request = {
        date: selectedDate,
        isSDDOpted: false,
        shipping: {
            name: "standard",
            price: "$0.0"
        },
        arrivalTime: "0800-1200",
        directShip: "Y"
    };
    return JSON.stringify(request);
}*/

export const setDueDate = async (duedatereq, dispatch, visitId,servicesOrdered,PrevSelectedProudct,autoPay,resetDDattemptExceeded,satelliteEligible,satelliteSelect, flowType, baseOrderDetail=null, fiosInABox,techY=null) => {
    try
    {
        const tech = techY && '?tech=' +techY || '';   
        let url = apiUrl().setDueDate + tech;
        dispatch({ 
            type: 'LOADER_ACTIVE', 
            value: { isLoaderActive: true, isLoaderText: "Lets wait for a moment, we are processing your request.", isLoaderImg: "loader" } 
        });
        reserveDueDateAPICount = reserveDueDateAPICount + 1;
        return api(url, 'POST', duedatereq).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                
                dispatchSDDEvents(dispatch,autoPay, servicesOrdered,PrevSelectedProudct,visitId);
                
            }
            else
            {
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code) && 
                    (InHomeUtils.getIndexOf(response.meta.code, '400') || InHomeUtils.getIndexOf(response.meta.code, '500')) && setDueDateAPIFailCount > 3) {
                        setDueDateAPIFailCount = setDueDateAPIFailCount + 1;
                        setDueDate(duedatereq, dispatch, visitId,servicesOrdered,PrevSelectedProudct,autoPay,resetDDattemptExceeded,satelliteEligible,satelliteSelect, flowType, baseOrderDetail=null, fiosInABox);
                }
                if(!resetDDattemptExceeded)
                {
                    if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.description) && response.meta.description !== "" &&
                    reserveFailMatch(response.meta.description)){
                        
                        dispatch({
                            type: 'RESET_DUEDATE',
                            value:''
                        });
        
                        dispatch({
                            type: 'RESET_DUEDATE_MESSAGE',
                            value:{
                                resetDD :true,
                                attemptExceeded:true
                            }
                        });
        
                        if (satelliteEligible === "N") {                            
                            try {
                                if (setDueDateAPIRetryCount < 3) {
                                    getDueDates(dispatch,visitId,'', flowType, baseOrderDetail, fiosInABox);
                                    setDueDateAPIRetryCount = setDueDateAPIRetryCount + 1;
                                }
                            }
                            catch (ex) {
                                catchJSException('Checkout', this.props.appState.visitId, 'setDueDate_Retry', ex);
                                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                            }                            
                        }      
                        else if (satelliteEligible === "Y" && (InHomeUtils.isNotNull(satelliteSelect) && satelliteSelect !== '') ){
                            try {
                                if (setDueDateAPIRetryCount < 3) {
                                    getDueDates(dispatch,visitId,satelliteSelect, flowType, baseOrderDetail, fiosInABox);
                                    setDueDateAPIRetryCount = setDueDateAPIRetryCount + 1;
                                }
                            }
                            catch (ex) {
                                catchJSException('Checkout', this.props.appState.visitId, 'setDueDate_Retry', ex);
                                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                            }
                        }
                    }
                }
                else{

                    dispatchSDDEvents(dispatch,autoPay,servicesOrdered,PrevSelectedProudct,visitId);
                }

                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO,visitId,PAGEACTIVITY.PAGE.ASYNC,'RESERVE Date API Error',PAGEACTIVITY.UA));
                
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            return true;
        }).catch(error => {
            if (!resetDDattemptExceeded && reserveDueDateAPICount < 3) {
                dispatch({
                    type: 'RESET_DUEDATE',
                    value: ''
                });
                dispatch({
                    type: 'RESET_DUEDATE_MESSAGE',
                    value: {
                        resetDD: true,
                        attemptExceeded: true
                    }
                });
                if (satelliteEligible === "N") {
                    // getDueDates(dispatch, visitId, '', flowType, baseOrderDetail, fiosInABox);
                    try {
                        if (setDueDateAPIRetryCount < 3) {
                            getDueDates(dispatch, visitId, '', flowType, baseOrderDetail, fiosInABox);
                            setDueDateAPIRetryCount = setDueDateAPIRetryCount + 1;
                        }
                    }
                    catch (ex) {
                        catchJSException('Checkout', this.props.appState.visitId, 'setDueDate_CatchBlock_Retry', ex);
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    }   
                }
                else if (satelliteEligible === "Y" && (InHomeUtils.isNotNull(satelliteSelect) && satelliteSelect !== '')) {
                    //getDueDates(dispatch, visitId, satelliteSelect, flowType, baseOrderDetail, fiosInABox);
                    try {
                        if (setDueDateAPIRetryCount < 3) {
                            getDueDates(dispatch, visitId, satelliteSelect, flowType, baseOrderDetail, fiosInABox);
                            setDueDateAPIRetryCount = setDueDateAPIRetryCount + 1;
                        }
                    }
                    catch (ex) {
                        catchJSException('Checkout', this.props.appState.visitId, 'setDueDate_CatchBlock_Retry', ex);
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    }   
                }
            }
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            let errorMsg = `MethodName:setDueDate,errorMessage:${error.message}`;
           // vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
            logKafka("ERROR", "SETDUEDATE", errorMsg, getErrorLogUrl, "applogs", visitId);
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            return false;
        });
    }
    catch(ex)
    {
        catchJSException('Checkout',this.props.appState.visitId,'setDueDate',ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        return false;
    }
}

export const getDueDates = (dispatch, visitId, satelliteSelect, flowType) => {
    try {
        let url = apiUrl().getDueDate + "?satellite=" + satelliteSelect + "&appId=" + flowType;
        let strdaysgapformat = "fios:";
        let noofdays = "";
        let dt2 = new Date();
        let dt1 = "";

        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Lets wait for a moment, we are processing your request.", isLoaderImg: "loader" }
        });

        api(url, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                dispatch({
                    type: CheckOut.onDueDateSuccess,
                    value: response.data
                });
                let promoKeywordFlowVal = store && store.getState() && store.getState().buildProduct && store.getState().buildProduct.isPromoKeywordFlow ? true : false;

                if(!promoKeywordFlowVal){
                    updateIntent(visitId, response.data.dispatchType, dispatch);
                }

                if (response.data.dispatchType === "O") {
                    strdaysgapformat = strdaysgapformat + "freetech";
                    if (response.data.duedates[0].directShip === "Y") {
                        strdaysgapformat = strdaysgapformat + "+ directship ";
                    }
                    dt1 = new Date(response.data.duedates[0].dueDate);

                    dispatch({ type: CheckOut.updateInstallationAccordionStatus, value: 'required' });
                }

                if (response.data.dispatchType === "I" && response.data.shipping[1]) {
                    url = apiUrl().storePickUp;
                    api(url, 'GET', '').then(strPkpResponse => {
                        let spproduct = [];
                        let plproduct = [];
                        if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.response) && InHomeUtils.isNotNull(response.response.getClosestInvAvailabilityLoc) && strPkpResponse.response.getClosestInvAvailabilityLoc.record) {
                            strPkpResponse.response.getClosestInvAvailabilityLoc.record.map(obj => {
                                if (obj.type === "VZMDU") { //Package Locker Stores
                                    return (
                                        plproduct.push({ addressL1: obj.store.location.addressline1, addressL2: `${obj.store.location.city} ${obj.store.location.state} ${obj.store.location.zip}`, distance: obj.store.approxmiles, contactNo: obj.store.telephone, openHrs: obj.store.operatinghours1 }))
                                }
                                else {
                                    return (
                                        spproduct.push({ addressL1: obj.store.location.addressline1, addressL2: `${obj.store.location.city} ${obj.store.location.state} ${obj.store.location.zip}`, distance: obj.store.approxmiles, contactNo: obj.store.telephone, openHrs: obj.store.operatinghours1 }))
                                }
                            })
                        }
                        strdaysgapformat = strdaysgapformat + "selfstoreormail";
                        dt1 = new Date(response.data.duedates[0].dueDate);
                        dispatch({
                            type: CheckOut.updateStorePickUpData,
                            value: spproduct
                        });
                        if (plproduct.length > 0) {
                            dispatch({
                                type: CheckOut.updatePackageLockerData,
                                value: plproduct
                            });
                        }
                    })

                    url = apiUrl().getDueDate + "?satellite=&triggerShipCall=Y" + "&appId=" + flowType;
                    api(url, 'GET', '').then(response => {
                        if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                            dispatch({
                                type: CheckOut.onDueDateSuccess,
                                value: response.data
                            });
                            if(!promoKeywordFlowVal){
                                updateIntent(visitId, response.data.dispatchType, dispatch);
                            }
                            dt1 = new Date(response.data.duedates[0].dueDate);
                            dispatch({
                                type: 'CHANGE_INSTALL_CALENDAR',
                                value: {
                                    selDueDateType: "EONTSELFINSTALL",
                                    selDeliveryOption: "PickUp"
                                }
                            })
                        }
                        else {
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.ASYNC, 'GET DUE DATE Failure', PAGEACTIVITY.UA));
                        }
                    });
                }
                else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.dispatchType) && response.data.dispatchType === "I") {
                    strdaysgapformat = strdaysgapformat + "self";
                    dt1 = new Date(response.data.duedates[0].dueDate);
                }

                noofdays = dt1 && Math.floor((Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate()) - Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate())) / (1000 * 60 * 60 * 24));

                strdaysgapformat += "^ " + noofdays + "d | _";
                scDataDetails.initialInstallOptions = strdaysgapformat;
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.ASYNC, 'GET DUE DATE Failure', PAGEACTIVITY.UA));
                logKafka("ERROR", "DUEDATE", "GET DUE DATE Failure", getLogUrl, "applogs", visitId);
            }

            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
            .catch(error => {
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:getDueDates,errorMessage:${error.message}`;
                logKafka("ERROR", "DUEDATE", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('Checkout', visitId, 'getDueDates', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
}

export const sameDayDelivery = (dispatch, visitId) => {
    try {
        let url = apiUrl().sameDaydelivery;
        api(url, 'GET', '').then(response => {
            //response={"meta":{"code":201.01,"description":"Same day delivery successful","timestamp":"Wed Dec 12 06:24:41 UTC 2018"},"data":{"prismShippingOptions":[{"shippingoption":"SAME_DAY","valid":"YES"}]}};         
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '201')) {

                let isSDD = (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.prismShippingOptions)
                    && response.data.prismShippingOptions.length > 0 && response.data.prismShippingOptions[0].valid.toLowerCase() === "yes") ? true : false
                dispatch({
                    type: CheckOut.updateSameDayDelivery,
                    value: isSDD
                });

                if (isSDD) {
                    dispatch({
                        type: 'CHANGE_INSTALL_CALENDAR',
                        value: {
                            selDueDateType: "EONTSELFINSTALL",
                            selDeliveryOption: "SDD"
                        }
                    })
                }
            }
            else {
                dispatch({
                    type: CheckOut.updateSameDayDelivery,
                    value: false
                })
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.ASYNC, 'SameDayDelivery API Failure', PAGEACTIVITY.UA));
                logKafka("ERROR", "SAMEDAYDELIVERY", "SameDayDelivery API Failure", getLogUrl, "applogs", visitId);
            }
        })
            .catch(error => {
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:sameDayDelivery,errorMessage:${error.message}`;
                logKafka("ERROR", "SAMEDAYDELIVERY", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('Checkout', visitId, 'sameDayDelivery', ex);
    }
}

//end installation
export const tosAccordionOpen = (status, dispatch) => {
    dispatch({ type: CheckOut.tosAccordionOpen, value: status })
};

export const tosCheck = (status, dispatch) => {
    dispatch({ type: CheckOut.tosChecked, value: status })
};

export const tosMSDCheck = (status, dispatch) => {
    dispatch({ type: CheckOut.tosMonthlyServiceDisclosureChecked, value: status })
};

export const homeSecurityCheck = (status, dispatch) => {
    dispatch({ type: CheckOut.homeSecurityChecked, value: status })
};

export const homeSecureCheck = (status, dispatch) => {
    dispatch({ type: CheckOut.homeSecureChecked, value: status })
}

export const homeSecurePlusCheck = (status, dispatch) => {
    dispatch({ type: CheckOut.homeSecurePlusChecked, value: status })
}

export const hdpCheck = (status, dispatch) => {
    dispatch({ type: CheckOut.hdpChecked, value: status })
};

export const showTosErrorMsg = (status, dispatch) =>{
    dispatch({ type: 'SHOW_TOS_ERROR_MSG', value: status})
};

export const showTosVoiceErrorMsg = (status, dispatch) =>{
    dispatch({ type: 'SHOW_TOS_VOICE_ERR_MSG', value: status})
};

export const showTosVHDPErrorMsg = (status, dispatch) => {
    dispatch({ type: "SHOW_TOS_VHDP_ERROR_MSG", value: status });
}


export const tosVoiceCheck = (status, dispatch) => {
    dispatch({ type: CheckOut.tosVoiceChecked, value: status })
};

export const tosViewed = (status, dispatch) => {
    dispatch({ type: CheckOut.tosViewed, value: status })
};

export const checkExternalCreditCheck = (dispatch) => {
    dispatch({ type: CheckOut.onUpdateExternalCreditCheck, value: '' })
};

export const noSSNCheck = (dispatch) => {
    dispatch({ type: CheckOut.noSSNCheck, value: '' })
};

/* PaperFreeBilling and AutoPay Start Here */
export const ContinueClick = (action, dispatch) => {
    dispatch({
        type: CheckOut.onPFBClick,
        value: action
    });
};

export const PaymentModeChanges = (action, dispatch) => {
    dispatch({
        type: CheckOut.onPaymentModeChange,
        value: action
    });
};

export const CheckAutoPayOffer = (action, dispatch) => {
    dispatch({
        type: CheckOut.onCheckAutoPayOffer,
        value: action
    });
};

export const updateChoice = (dispatch, value) => {
    dispatch({
        type: CheckOut.updateRTAChoice,
        value: value
    });
}

export const performEID = (dispatch, request, creditFailAttempts, visitId) => {
    try {
        let url = apiUrl().performEID;
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Lets wait for a moment, we are processing your request.", isLoaderImg: "loader" }
        });
        api(url, 'POST', JSON.stringify(request)).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code)) {
                dispatch({ type: CheckOut.updateRTAStatus, value: false })
                dispatch({ type: CheckOut.updateFinalBillStatus, value: false })
                if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.result) && InHomeUtils.isNotNull(response.data.result.reason)) {
                    if (response.data.result.reason === 'SUCCESS') {
                        dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: true })

                        if (response.data.icredit.depositinfo.depositamount > 0) {
                            dispatch({ type: CheckOut.updateDepositInfo, value: true })
                            dispatch({ type: CheckOut.updateDepositAmount, value: response.data.icredit.depositinfo.depositamount })
                        }
                        else {
                            dispatch({ type: CheckOut.updateDepositInfo, value: false })
                        }
                        dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'completed' })
                        dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: 'completed' })

                        tempSCData.detailPageName = "ec| checkout| info and credit- crd chk";
                        tempSCData.creditCheck = "Pass";
                        updateSCcustomEvent("checkoutInit", "ddCheckoutEvent", "detailPageName");

                        tempSCData.detailPageName = "ec| checkout| info and credit- crd chk rta success";
                        tempSCData.creditCheck = "Pass";
                        updateSCcustomEvent("checkoutInit", "ddCheckoutEvent", "detailPageName");
                    }
                    else if (response.data.result.reason === 'FAILURE') {
                        dispatch({ type: CheckOut.updateCreditFailAttempts, value: creditFailAttempts + 1 })
                        dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: false })
                        dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'change' })
                        dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: 'change' })
                        dispatch({ type: CheckOut.updateDepositInfo, value: false })

                        tempSCData.detailPageName = "ec| checkout| install tos and summary - install| credit fail";
                        tempSCData.creditCheck = "Fail";
                        updateSCcustomEvent("installandtosLoad", "ddCheckoutEvent", "detailPageName");

                        tempSCData.detailPageName = "ec| checkout| info and credit- crd chk rta fail";
                        tempSCData.creditCheck = "Fail";
                        updateSCcustomEvent("checkoutInit", "ddCheckoutEvent", "detailPageName");
                    }
                }
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });

        })
            .catch(error => {
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:performEID,errorMessage:${error.message}`;
                logKafka("ERROR", "Checkout", errorMsg, getErrorLogUrl, "applogs");
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('Checkout', visitId, 'performEID', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
}

/* PaperFreeBilling and AutoPay End Here */

export const doCreditCheck = (visitId, dispatch, creditCheckEncryptedValue, noSSNCheck, lqState, saveState, creditFailAttempts, tcChatInfo, appData) => {
    try {
        let creditCheck = apiUrl().creditCheck;
        let MTN = "";
        if (InHomeUtils.isNotNull(tcChatInfo) && InHomeUtils.isNotNull(tcChatInfo.contactInfo) && InHomeUtils.isNotNull(tcChatInfo.contactInfo.phoneNo)) {
            MTN = tcChatInfo.contactInfo.phoneNo.ph1 + tcChatInfo.contactInfo.phoneNo.ph2 + tcChatInfo.contactInfo.phoneNo.ph3;
        }
        let request = getCreditRequest(creditCheckEncryptedValue, noSSNCheck, visitId);
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Getting your installation dates", isLoaderImg: "loader" }
        });
        if (creditFailAttempts < 3) {
            api(creditCheck, 'POST', request).then(response => {
                //response= resp.creditResponse;
                if (appData.flowType != "MV") {
                    // saveAction.smartSave(dispatch, visitId, "passive", true, false, appData.mon_no, MTN, true);
                }
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                    dispatch({
                        type: CheckOut.onUpdateCreditCheck,
                        value: response.data
                    });
                    dispatch({
                        type: CheckOut.updateCRVNunmber,
                        value: response.data.icredit.icreditrefno
                    })
                    if (response.data.icredit.depositinfo.depositamount > 0) {
                        dispatch({ type: CheckOut.updateDepositInfo, value: true })
                        dispatch({ type: CheckOut.updateDepositAmount, value: response.data.icredit.depositinfo.depositamount })
                    }
                    if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.result) && InHomeUtils.isNotNull(response.data.result.reason)) {
                        if (response.data.result.reason === 'SUCCESS') {

                            tempSCData.detailPageName = "ec| checkout| info and credit- crd chk";
                            tempSCData.installOptions = scDataDetails.initialInstallOptions;
                            tempSCData.creditCheck = "Pass";
                            updateSCcustomEvent("checkoutInit", "ddCheckoutEvent", "detailPageName");
                            tempSCData.detailPageName = "ec| checkout| info and credit - autopay-offer selected"
                            updateSCcustomEvent("pfbandAutoPayLoad", "ddCheckoutEvent", "detailPageName");
                            dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: true })
                            dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'completed' })
                            dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: 'completed' })

                            creditInfoUpdate("SUCCESS", tcChatInfo, response.data.icredit.icreditrefno);
                        }
                        else if (response.data.result.reason === 'FAILURE') {

                            dispatch({ type: CheckOut.updateCreditFailAttempts, value: creditFailAttempts + 1 })
                            dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: false })

                            //Check If Final Bill Required
                            if (response.data.icredit.depositinfo.finalbillamountrequired === "Y") {
                                dispatch({ type: CheckOut.updateFinalBillStatus, value: true })
                                dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'required' })
                            }
                            //if RTA Q's required                
                            else if (InHomeUtils.isNotNull(response.data.questionanswer) && response.data.questionanswer.length > 0) {
                                let rtadata = []
                                response.data.questionanswer.map(obj => { return rtadata.push({ questionnumber: obj.questionnumber, choicenumber: 0 }) })
                                dispatch({ type: CheckOut.updateRTAQs, value: { rtaquesionarrie: response.data.questionanswer, rtadata: rtadata } })
                                dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'required' })
                                dispatch({ type: CheckOut.updateRTAStatus, value: true })

                            }
                            else {
                                dispatch({ type: CheckOut.updateInstallationAccordionStatus, value: 'required' })
                                dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'change' })
                                dispatch({ type: CheckOut.updateDepositInfo, value: false })
                            }
                            creditInfoUpdate("FAILURE", tcChatInfo, response.data.icredit.icreditrefno);
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.CC, 'CREDIT CHECK FAILED_CNT:' + creditFailAttempts, PAGEACTIVITY.UA));
                            logKafka("ERROR", "doCreditCheck", "CREDIT CHECK FAILED_CNT:" + creditFailAttempts, getLogUrl, "applogs", visitId);
                        }
                    }
                } else {
                    creditInfoUpdate("FAILURE", tcChatInfo, "");
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.CC, 'CREDIT API Failure_CNT:' + creditFailAttempts, PAGEACTIVITY.UA));
                    logKafka("ERROR", "doCreditCheck", "CREDIT CHECK FAILED_CNT:" + creditFailAttempts, getLogUrl, "applogs", visitId);
                }
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            })
                .catch(error => {
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                    let errorMsg = `MethodName:doCreditCheck,errorMessage:${error.message}`;
                    logKafka("ERROR", "Checkout", errorMsg, getErrorLogUrl, "applogs");
                    errorAction("LBO", "Checkout", error.message, "applogs", visitId, dispatch, true, "validateCredit");
                    creditInfoUpdate("FAILURE", tcChatInfo);
                });
        }
        else {
            dispatch({ type: CheckOut.updateCreditFailAttempts, value: creditFailAttempts + 1 })
            dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: false })
            dispatch({ type: CheckOut.updateFinalBillStatus, value: false })
            dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'change' })
            dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: 'change' })
            dispatch({ type: CheckOut.updateRTAStatus, value: false })
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        }
    } catch (ex) {
        catchJSException('Checkout', visitId, 'doCreditCheck', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
};

export const doCreditAssessment = (dispatch, visitId) => {
    try {
        let creditCheck = apiUrl().creditAssessment;

        api(creditCheck, 'GET').then(response => {
            dispatch({
                type: MTNValidation.updateisAssessmentRequired,
                value: false
            });
            //response= resp.creditResponse;
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                dispatch({
                    type: CheckOut.onUpdateCreditCheck,
                    value: response.data
                });
                dispatch({
                    type: CheckOut.updateCRVNunmber,
                    value: response.data.icredit.icreditrefno
                })
                if (response.data.result.reason === 'SUCCESS') {
                    tempSCData.detailPageName = "ec| checkout| info and credit - billinfo| vzw mtn credit success";
                    dispatch({
                        type: CheckOut.updateBAUCC,
                        value: false
                    })
                }
                else if (response.data.result.reason === 'FAILURE') {
                    tempSCData.detailPageName = "ec| checkout| info and credit - billinfo| vzw mtn credit fail";
                    dispatch({
                        type: CheckOut.updateBAUCC,
                        value: true
                    })
                }
            }
            else {
                tempSCData.detailPageName = "ec| checkout| info and credit - billinfo| vzw mtn credit fail";
                dispatch({
                    type: CheckOut.updateBAUCC,
                    value: true
                })
            }
            updateSCcustomEvent("checkoutInit", "ddCheckoutEvent", "detailPageName");
        })
            .catch(error => {
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:doCreditAssessment,errorMessage:${error.message}`;
                logKafka("ERROR", "Checkout", errorMsg, getErrorLogUrl, "applogs");
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                dispatch({
                    type: CheckOut.updateBAUCC,
                    value: true
                })
            });
    } catch (ex) {
        catchJSException('Checkout', visitId, 'doCreditAssessment', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
}

const getCreditRequest = (creditCheckEncryptedValue, noSSNCheck, visitId) => {
    try {
        let request = {
            client: {
                name: 'vzcom',
                clientid: 'vzcom'
            },
            data: {
                creditinfo: {
                    dob: creditCheckEncryptedValue.protected_dob,
                    ssn: creditCheckEncryptedValue.protected_ssn,
                    dobkeyid: creditCheckEncryptedValue.key_id,
                    dobphase: creditCheckEncryptedValue.phase,
                    ssnkeyid: (noSSNCheck ? "" : creditCheckEncryptedValue.key_id),
                    ssnphase: (noSSNCheck ? "" : creditCheckEncryptedValue.phase),
                    financialinstitutionname: '',
                    idtype: '',
                    currntvztelnum: ''
                },
                externalpermitted: true,
                affiliateshare: false,
                requesteidquestions: 'y',
                ipaddress: '127.0.0.0',
                isprepaidfiosindicator: false
            }
        }
        return JSON.stringify(request);
    } catch (ex) {
        catchJSException('Checkout', visitId, 'getCreditRequest', ex);
    }
}

export const fNameErr = (status, dispatch) => {
    dispatch({ type: FinalBill.fNameErr, value: status })
};

export const lNameErr = (status, dispatch) => {
    dispatch({ type: FinalBill.lNameErr, value: status })
};

export const cTypeErr = (status, dispatch) => {
    dispatch({ type: FinalBill.cTypeErr, value: status })
};

export const cNumErr = (status, dispatch) => {
    dispatch({ type: FinalBill.cNumErr, value: status })
};

export const cVVErr = (status, dispatch) => {
    dispatch({ type: FinalBill.cVVErr, value: status })
};

export const expMonthErr = (status, dispatch) => {
    dispatch({ type: FinalBill.expMonthErr, value: status })
};

export const expYearErr = (status, dispatch) => {
    dispatch({ type: FinalBill.expYearErr, value: status })
};

export const getVzId = (visitId, dispatch) => {
    try {
        let getVzIdUrl = apiUrl().getVZID;
        api(getVzIdUrl, 'GET', '').then(response => {

            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.status)) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO, visitId, PAGEACTIVITY.PAGE.ASYNC, 'getVzId API Error', PAGEACTIVITY.UA));
                logKafka("ERROR", "doCreditCheck", "getVzId API Error", getLogUrl, "applogs", visitId);
            }

            dispatch({
                type: 'GENERATE_VZID',
                value: response
            });
        })
            .catch(error => {
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:getVzId,errorMessage:${error.message}`;
                logKafka("ERROR", "Checkout", errorMsg, getErrorLogUrl, "applogs");
                errorAction("ERROR", "Checkout", error.message, "applogs", visitId, dispatch, false, "");
            });
    }
    catch (ex) {
        catchJSException('Checkout', visitId, 'getVzId', ex);
    }
};

export const checkSatelliteEligible = (dispatch, lqState, visitId, profileCart, buildProductState) => {
    try {
        let satelliteQualified = 'N';
        let isFiosTVQualified = false;
        let isOntSelfInstallCapable = false;
        let isDataAddedNewly = (!profileCart.ProfileDataProduct || (profileCart.ProfileDataProduct && profileCart.ProfileDataProduct.length == 0)) && buildProductState.internet.selectedProduct && (buildProductState.internet.selectedProduct.id || buildProductState.internet.selectedProduct.prodId) ? true : false;
        let isTvAddedNewly = !profileCart.ProfileTVProduct && buildProductState.tv.selectedProduct && (buildProductState.tv.selectedProduct.id || buildProductState.tv.selectedProduct.prodId) && buildProductState.tv.selectedProduct.prodType != "OTTBASIC" ? true : false;

        if (lqState && lqState.ecLQResponse && (isDataAddedNewly || isTvAddedNewly)) {
            if (lqState.ecLQResponse.services && lqState.ecLQResponse.services.filter(x => x.servicename.toLowerCase() == 'video' && x.qualified.toLowerCase() == 'y').length > 0) {
                isFiosTVQualified = true;
            }

            if (isFiosTVQualified && lqState.ecLQResponse.getLoopAvailabilityResponseMsg && lqState.ecLQResponse.getLoopAvailabilityResponseMsg.fttpAvailabilityDetailsAGR) {

                let fttpAvailabilityDetailsAGR = lqState.ecLQResponse.getLoopAvailabilityResponseMsg.fttpAvailabilityDetailsAGR;

                if (fttpAvailabilityDetailsAGR.ontSelfInstallCapable && fttpAvailabilityDetailsAGR.ontSelfInstallCapable.toLowerCase() == 'yes') {
                    isOntSelfInstallCapable = fttpAvailabilityDetailsAGR.ontSelfInstallCapable;
                }

                if (fttpAvailabilityDetailsAGR.ontAGR && fttpAvailabilityDetailsAGR.ontAGR.length > 0 && isOntSelfInstallCapable) {
                    let srvcs = fttpAvailabilityDetailsAGR.ontAGR[0].portDetailAGR;
                    for (let i = 0; i < srvcs.length; i++) {
                        if (InHomeUtils.isNotNull(srvcs[i].existingOntWiring) && srvcs[i].existingOntWiring === 'ETHERNET') {
                            satelliteQualified = "Y";
                        }
                    }
                }
            }
        }

        dispatch({ type: CheckOut.satelliteEligible, value: satelliteQualified })
    } catch (ex) {
        catchJSException('Checkout', visitId, 'checkSatelliteEligible', ex);
    }
};

export const satelliteClick = (dispatch, optionType) => {
    dispatch({ type: CheckOut.satelliteOption, value: optionType })
}

export const getCentralAgreementTos = async (visitId, dispatch) => {
    try {
        var host = window.location.host;
        let url = '';

        if (host.indexOf("sit") > -1 || host.indexOf("nte3") > -1 || host.indexOf("nte1") > -1 || host.indexOf("stage") > -1 || host.indexOf("preprod") > -1) {
            url = window.location.href.indexOf('espanol') > -1 ? '/inhome/getCentralAgreementTermsSpanishAEM' :'/inhome/getCentralAgreementTermsAEM';
        }
        else{
            if(window.location.href.indexOf('http://localhost') > -1 || window.location.host.includes('www.verizon.com') > -1) {
                url = window.location.href.indexOf('espanol') > -1 ? apiUrl().getCentralAgreementTermsSpanishAEM :apiUrl().getCentralAgreementTermsAEM;               
            }
        }

        console.log("getCentralAgreementTos url", url)
        return new Promise((resolve, reject) => {
            api(url, 'GET', '').then(async response => {
                let orderedKeys = response;
                if (InHomeUtils.isNotNull(response) && response !== "") {
                    if (InHomeUtils.isNotNull(response?.legalDocumentDetails)) {
                        dispatch({ type: 'GET_CENTRALAGREEMENT_TOS', value: response });
                    }
                }
                else {
                    let errorMsg = "AEM response not returned";
                    let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                    logKafka("ERROR", "getCentralAgreementTermsAEM", errorMsg, getErrorLogUrl, "applogs", visitId);
                }
                resolve(orderedKeys);
            })
                .catch(error => {
                    let errorMsg = `MethodName:getCentralAgreementTermsAEM,errorMessage:${error.message}`;
                    logKafka("ERROR", "getCentralAgreementTermsAEM", errorMsg, getErrorLogUrl, "applogs", "");
                });
        });
    }
    catch (ex) {
        catchJSException('getCentralAgreementTermsAEM', visitId, 'getCentralAgreementTermsAEM', ex);
    }
}

export const ecClearCheckoutStatus = (dispatch) => {
    dispatch({ type: 'EC_CLEAR_CHECKOUT_STATUS' })
    dispatch({ type: CheckOut.onSetDueDate, value: false });
}

export const satelliteContinueClick = (dispatch, action) => {
    dispatch({ type: CheckOut.satelliteClick, value: action })
    if (action == true) {
        dispatch({ type: CheckOut.updateSatelliteAccordionStatus, value: 'completed' })
    }
    else {
        dispatch({ type: CheckOut.updateSatelliteAccordionStatus, value: 'required' })
    }
}

export const getTos = (visitId, dispatch) => {
    try {
        let getVzIdUrl = apiUrl().getTermsAEM;//apiUrl().getTos;
        api(getVzIdUrl, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response))
                dispatch({ type: 'GET_TOS', value: response });
        })
            .catch(error => {
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:getTos,errorMessage:${error.message}`;
                logKafka("ERROR", "Checkout", errorMsg, getErrorLogUrl, "applogs");
                errorAction("ERROR", "Checkout", error.message, "applogs", visitId, dispatch, false, "");
            });
    }
    catch (ex) {
        catchJSException('Checkout', visitId, 'getTos', ex);
    }
};

export const showDueMonthlyDetails =(dispatch, action) => {
    dispatch({type: CheckOut.showDueMonthlyDetails, value:action})
}

export const returnEquipmentClick = (dispatch, optionType) => {
    dispatch({ type: CheckOut.returnEquipmentOption, value: optionType })
};

export const returnEquipmentContinueClick = (dispatch, action) => {
    dispatch({ type: CheckOut.returnEquipmentClick, value: action })
    dispatch({ type: CheckOut.updateReturnEquipAccordianStatus, value: 'completed' })
}

export const updateReturnEquipAccordian = (action, dispatch) => {
    dispatch({ type: CheckOut.updateReturnEquipAccordianStatus, value: action })
}

export const updateDeliveryOptionAccordion = (action, dispatch) => {
    dispatch({ type: CheckOut.updateDeliveryOptionAccordion, value: action })
}


export const getFaqCheckout = (dispatch, visitId, pageName) => {
    try {
        let url = apiUrl().getFaq + '/' + pageName;

        api(url, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response))
                dispatch({ type: 'FAQ_CHECKOUT_CONTENT', value: response });
        })
            .catch(error => {
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:getFaqCheckout,errorMessage:${error.message}`;
                logKafka("ERROR", "Checkout", errorMsg, getErrorLogUrl, "applogs");
                errorAction("ERROR", "buildProduct", error.message, "applogs", visitId, dispatch, false, "");
            });
    }
    catch (ex) {
        catchJSException('Checkout', visitId, 'getFaqCheckout', ex);
    }
}

export const setXpsResumeDetails = (visitId, dispatch, personalInfoCompleted, creditCheckCompleted, isOnlineCCFlow, addrID) => {
    try {
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true } });
        let url = apiUrl().getSmartCartPersonalInfo;
        api(url, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                let respData = response.data;
                let isvalidConatctInfo = false;
                if (InHomeUtils.isNotNull(respData.firstName) && InHomeUtils.isNotNull(respData.lastName) && InHomeUtils.isNotNull(respData.eMail) && InHomeUtils.isNotNull(respData.mtn) && InHomeUtils.isNotNull(respData.billingAddress)) {
                    if (respData.firstName !== "" && respData.lastName !== "" && respData.eMail !== "" && respData.mtn !== "" && respData.billingAddress !== "" && respData.firstName.toUpperCase() !== "XPS" && respData.lastName.toUpperCase() !== "XPS") {
                        isvalidConatctInfo = true;
                    }
                }
                if (personalInfoCompleted && isvalidConatctInfo && creditCheckCompleted) {
                    let contactInfo = {};
                    contactInfo = {
                        "fName": respData.firstName,
                        "lName": respData.lastName,
                        "isValidfName": true,
                        "isValidlName": true,
                        "eMailId": respData.eMail,
                        "isValidMail": true,
                        "isValidTN": true,
                        "phoneNo": {
                            "ph1": respData.mtn.slice(0, 3),
                            "ph2": respData.mtn.slice(3, 6),
                            "ph3": respData.mtn.slice(6, 10),
                        },
                        "isContactInfoValidated": true,
                    }
                    let billingAdrInfo = {};
                    billingAdrInfo = {
                        "isValidBillingAddress": true,
                        "billingAddress": respData.billingAddress,
                        "isBillingInfoValidated": true
                    }
                    dispatch({ type: CheckOut.updateNameInfo, value: contactInfo });
                    dispatch({ type: CheckOut.updateContactInfo, value: contactInfo });
                    dispatch({ type: "UPDATE_PHONE", value: contactInfo.phoneNo });
                    dispatch({ type: CheckOut.updateBillingAddrInfo, value: billingAdrInfo });

                    if (isOnlineCCFlow && !creditCheckCompleted) {
                        validateVZWOfferEligibility(dispatch, respData.mtn, visitId, false, addrID);
                        dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: 'required' })
                    }
                    else if (!creditCheckCompleted) {
                        dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: 'change' })
                    }
                    dispatch({ type: CheckOut.updatePersonalInfoAccordionStatus, value: 'completed' })
                    dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'completed' })
                    dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: true })
                }
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
            else {
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                errorAction("LBO", "PERSONALINFOERROR", response.meta.description, "applogs", visitId, dispatch, true, "PERSONALINFOERROR");
            }
        })
            .catch(error => {
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:setXpsResumeDetails,errorMessage:${error.message}`;
                logKafka("ERROR", "Checkout", errorMsg, getErrorLogUrl, "applogs");
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                errorAction("ERROR", "SETXPSRESUMEDETAILS", error.message, "applogs", visitId, dispatch, false, "");
            });
    }
    catch (ex) {
        catchJSException('Checkout', visitId, 'setXpsResumeDetails', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
};

export const targetLofTosEnable = (action, dispatch) => {
    dispatch({ type: "LOF_TOSENABLE", value: action })
}

export const dispatchSDDEvents = (dispatch, autoPay, servicesOrdered, PrevSelectedProudct, visitId) => {
    try {
        dispatch({ type: CheckOut.onSetDueDate, value: true });
        dispatch({ type: CheckOut.updateInstallationAccordionStatus, value: 'change' })
        dispatch({
            type: 'RESET_DUEDATE_MESSAGE',
            value: {
                resetDD: false,
                attemptExceeded: false
            }
        });

        //socAction.fetchPostSoc(dispatch, visitId);
        if (InHomeUtils.isNotNull(PrevSelectedProudct) && InHomeUtils.isNotNull(servicesOrdered) && (servicesOrdered !== PrevSelectedProudct.PrevSelectedProudct)) {
            dispatch({ type: CheckOut.PrevSelectedProd, value: servicesOrdered })
        }
        if (autoPay === 'required') {
            updateSCcustomEvent("pfbandAutoPayLoad", "ddCheckoutEvent", "")
            vzdlBuildProductPageEvents("info and credit - autopay and pfb");
        }
        // else{
        //     updateSCcustomEvent("installandtosLoad", "ddCheckoutEvent", "");            
        // }
    } catch (ex) {
        catchJSException('Checkout', visitId, 'action_dispatchSDDEvents', ex);

    }
}

export const setMovesCheckoutExp = (visitId, dispatch) => {
    // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true } });
    let url = apiUrl().MoveCheckoutExperience;
    api(url, 'GET', '').then(response => {
        if (response.meta.code === 200.0 || response.meta.code === 200.01 || response.meta.code === 200.02 && response.data !== null && response.data !== undefined) {
            let respData = response.data;
            let contactInfo = {};
            let mvCheckout = {};
            contactInfo = {
                "fName": respData.contactInfo.firstName,
                "lName": respData.contactInfo.lastName,
                "isValidfName": true,
                "isValidlName": true,
                "eMailId": respData.contactInfo.eMail,
                "isValidMail": true,
                "isValidTN": true,
                "phoneNo": {
                    "ph1": respData.contactInfo.mtn.slice(0, 3),
                    "ph2": respData.contactInfo.mtn.slice(3, 6),
                    "ph3": respData.contactInfo.mtn.slice(6, 10),
                }
            }
            mvCheckout = {
                //    "autopayInProfile":respData.autopayInProfile,
                //    "PFBInProfile":respData.PFBInProfile,
                "depositInProfile": respData.profileDeposit,
                "depositAmount": respData.depositAmount,
                "returnEquipment": respData.returnEquipment
            }
            dispatch({ type: CheckOut.updateNameInfo, value: contactInfo });
            dispatch({ type: CheckOut.updateContactInfo, value: contactInfo });
            dispatch({ type: "UPDATE_PHONE", value: contactInfo.phoneNo });
            dispatch({ type: CheckOut.mvCheckout, value: mvCheckout });

            // dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'required' })
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });

        }
    })
        .catch(error => {
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            errorAction("ERROR", "setMovesCheckoutExp", error.message, "applogs", visitId, dispatch, false, "");
        });
};

export const updateNonMTNTrackerInCart = (visitId, dispatch) => {
    try {
        logOtherInfo(detailsInfo('checkout', visitId, 'updateNonMTNTrackerINCart', "Inside updateNonMTNTrackerINCart"));
        
        let url = apiUrl().updateCartAcc + '/' + visitId;
        let request = {
            productId: "R3508",
            productType: "DUMMY",
            quantity: "1",
            serviceType: "DATA",
            status: "add"
        }
       
        api(url, 'POST', JSON.stringify(request)).then(resp => {
            if (InHomeUtils.isNotNull(resp) && InHomeUtils.isNotNull(resp.meta) && InHomeUtils.getIndexOf(resp.meta.code, '200')) {
                dispatch({ type: 'NON_MTN_TRACKER_UPDATED', value: true });
            }
        })
        .catch(error => {
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            logOtherInfo(detailsInfo('checkout', visitId, 'updateNonMTNTrackerINCart', "updateNonMTNTrackerINCart - exception"));
           // vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
            let errorMsg = `MethodName:updateNonMTNTrackerINCart,errorMessage:${error.message}`;
            logKafka("ERROR", "updateNonMTNTrackerINCart", errorMsg, getErrorLogUrl, "applogs", visitId);
        });
    }
    catch (ex) {
        catchJSException('checkout', visitId, 'updateNonMTNTrackerINCart', ex);
    }
    
}

export const setMovesCheckoutExperienceFrmJSON = (visitId, dispatch) => {
    // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true } });
    var checkoutJSON = require('./../../containers/move/checkoutExpJson.json');
    let url = apiUrl().getCartAcc;
    api(url, 'GET', '').then(response => {
        // alert(response);
        //if (response.meta.code === 200.02 && response.data !==null && response.data!== undefined) {
        // let respData=response.data;
        if (response.meta.code === 500.01) {
            let respData = checkoutJSON.data;
            let contactInfo = {};
            let mvCheckout = {};
            contactInfo = {
                "fName": respData.contactInfo.firstName,
                "lName": respData.contactInfo.lastName,
                "isValidfName": true,
                "isValidlName": true,
                "eMailId": respData.contactInfo.eMail,
                "isValidMail": true,
                "isValidTN": true,
                "phoneNo": {
                    "ph1": respData.contactInfo.mtn.slice(0, 3),
                    "ph2": respData.contactInfo.mtn.slice(3, 6),
                    "ph3": respData.contactInfo.mtn.slice(6, 10),
                }
            }
            mvCheckout = {
                // "autopayInProfile":respData.autopayInProfile,
                // "PFBInProfile":respData.PFBInProfile,
                "depositInProfile": respData.profileDeposit,
                "depositAmount": respData.depositAmount,
                "returnEquipment": respData.returnEquipment
            }
            dispatch({ type: CheckOut.updateNameInfo, value: contactInfo });
            dispatch({ type: CheckOut.updateContactInfo, value: contactInfo });
            dispatch({ type: "UPDATE_PHONE", value: contactInfo.phoneNo });
            dispatch({ type: CheckOut.mvCheckout, value: mvCheckout });

            // dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'required' })
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });

        }
    })
        .catch(error => {
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            errorAction("ERROR", "setMovesCheckoutExp", error.message, "applogs", visitId, dispatch, false, "");
        });
}

export const laborDayMessage = (action, dispatch) => {
    dispatch({ type: 'LABORDAY_MESSAGE', value: action })
}

export const mAndHBannerDecider = (dispatch) => {
    try {
        const isVZWWireless = store.getState().signIn.response.isVZWWireless === "N" ? false : true
        if (!isVZWWireless) {
            const profileCartInternetProduct = store.getState().ecProfileCart.ProfileDataProduct
            const cartInterentProduct = store.getState().buildProduct.internet.selectedProduct
            let isDataGig = false

            let isDataInOrder = profileCartInternetProduct || cartInterentProduct ? true : false
            if (isDataInOrder && cartInterentProduct !== null) {
                isDataGig = (cartInterentProduct.prodName || cartInterentProduct.name).toLowerCase().includes("giga") ? true : false
            } else if (profileCartInternetProduct !== null && cartInterentProduct === null) {
                isDataGig = (profileCartInternetProduct.prodName || profileCartInternetProduct.name).toLowerCase().includes("giga") ? true : false


            }
            if (isDataInOrder) {
                dispatch({ type: "MNH_BANNER_DECIDER", isDataInOrder, isDataGig })
            }
        } else {
            dispatch({ type: "MNH_BANNER_DECIDER", isDataInOrder: false, isDataGig: false })
        }
    }
    catch (error) {
        console.log("error", error)
    }
}

export const storeDeliveryMethod = async (dispatch, value,visitId) => {
    try {
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true } });
        let url = apiUrl().updateintentcartAcc + '/' + visitId;
        let payload ={
            key: "delivery",
            value: value,
            action: "ADD"
        }
        let response  = await api(url,'POST',JSON.stringify(payload))
  
        dispatch({
            type: "UPDATE_CART",
            value: {
                cartResponse: InHomeUtils.isNull(response.data.cartTierPricing) ? null : response.data.cartTierPricing,
                cartHeader: InHomeUtils.isNull(response.data.cartTierPricing) ? null : getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                cartData: InHomeUtils.isNull(response.data.cartTierPricing) ? null : getCartData(response.data.cartTierPricing.tierContent, visitId),
                cartOrderDetail: InHomeUtils.isNull(response.data.cartTierPricing) ? null : response.data.orderDetail
            }
        });
        dispatch({ type: "STORE_DELIVERY_METHOD", value })
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    } catch (ex) {
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        catchJSException('Checkout', visitId, 'updateIntenet', ex);
        console.log('error', ex)
    }
}

export const enableScreeningButton = (value, dispatch, visitId) => {
    dispatch({ type: 'SCREENING_ENBALE_BUTTON', value: value });
}

export const focusOnCalendar = (value, dispatch, visitId) => {
    dispatch({ type: 'FOCUS_CALENDAR', value: value });
}

export const updateScreeningChoice = (value, dispatch, visitId) => {
    dispatch({ type: 'SCREENING_SELECTED_OPTION', value: value });
}

export const toggleReviewOrderSection = (value, dispatch) => {
    dispatch({ type: 'TOGGLE_REVIEW_ORDER_VIEW', value: value });
}

export const toggleTosSection = (value, dispatch) => {
    dispatch({ type: 'TOGGLE_TOS_VIEW', value: value });
}

export const sendDataToVzw = async (gig,dispatch)=>{
try{
    // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true } });
    let url = apiUrl().generateTokenForVzw
    let payload = {
        includeFullOnlineProfile:"Y",
        includeFullPendingOrderDetails: "Y",
        sourceSystemId:"",
        gig:gig?"Y":"N"
        }
    let response  =  await api(url,'POST',JSON.stringify(payload))
    return response


}catch(error){
console.log("error",error)
}
}